// extracted by mini-css-extract-plugin
export default {"paper_container":"Languages_paper_container__MN0Tg","header_title":"Languages_header_title__QmKrM","search_add_container":"Languages_search_add_container__asRvQ"};